import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigContext } from '../../context';

export const useUsersTable = () => {
  const { t } = useTranslation();

  const { t: ctxT } = useTranslation('', { keyPrefix: 'orgDashboardUsers' });

  const { fields } = useContext(ConfigContext).config.elements.profile;

  const getTableColumnLabel = useCallback(
    (value: string) => {
      const localiseKey = fields[value.toLowerCase() as keyof typeof fields]?.localiseKey;

      return localiseKey ? t(localiseKey) : ctxT(value);
    },
    [ctxT, fields, t]
  );

  return { getTableColumnLabel };
};
